import { reportUnexpectedError } from '@/shared/infrastructure/observability/reportUnexpectedError'
import type { SubmissionRepository } from '../application/SubmissionRepository'

export function createResilientSubmissionRepository(
  primary: SubmissionRepository,
  fallback: SubmissionRepository,
): SubmissionRepository {
  return {
    async listFeed() {
      try {
        return await primary.listFeed()
      } catch (error) {
        reportUnexpectedError(error, { feature: 'submissions', operation: 'listFeed', fallback: true })
        const result = await fallback.listFeed()
        return {
          ...result,
          meta: {
            ...result.meta,
            source: 'fixture-fallback',
            fallbackReason: 'SUBMISSIONS_REMOTE_UNAVAILABLE',
          },
        }
      }
    },
    async getPipelineSettings() {
      try {
        return await primary.getPipelineSettings()
      } catch (error) {
        reportUnexpectedError(error, {
          feature: 'submissions',
          operation: 'getPipelineSettings',
          fallback: true,
        })
        return fallback.getPipelineSettings()
      }
    },
    // Les écritures ne se replient jamais sur les fixtures.
    updatePipelineSettings(command) {
      return primary.updatePipelineSettings(command)
    },
    recordCallOutcome(command) {
      return primary.recordCallOutcome(command)
    },
    declineProposal(command) {
      return primary.declineProposal(command)
    },
    // Lecture sans repli fictif : un faux contrat proposé à l'assignation serait une faute.
    findContractsByPhone(phones) {
      return primary.findContractsByPhone(phones)
    },
    assignContractToLead(command) {
      return primary.assignContractToLead(command)
    },
  }
}
